var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3569 8.49996C17.3569 9.21072 16.7811 9.78608 16.0711 9.78608H10.2854V15.5718C10.2854 16.2826 9.70968 16.8571 8.99972 16.8571C8.28977 16.8571 7.71401 16.2826 7.71401 15.5718V9.78608H1.92829C1.21834 9.78608 0.642578 9.21072 0.642578 8.49996C0.642578 7.78921 1.21834 7.21465 1.92829 7.21465H7.71401V1.42894C7.71401 0.718179 8.28977 0.142822 8.99972 0.142822C9.70968 0.142822 10.2854 0.718179 10.2854 1.42894V7.21465H16.0711C16.7823 7.21425 17.3569 7.7888 17.3569 8.49996Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.aba7b89f43f86888c159433b9ff3bf15.svg";
export { ForwardRef as ReactComponent };